export default {
  name: "CashOnly",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 27H4c-1.16 0-2-.84-2-2V7c0-1.16.84-2 2-2h24c1.16 0 2 .84 2 2v18c0 1.16-.84 2-2 2zM4 7v18h24.05L28 7H4zm13 8.06v-2.97c1.49.26 1.88 1.09 2.02 1.75.12.54.64.88 1.19.77.54-.12.88-.65.77-1.19-.25-1.15-1.1-3-3.98-3.35V10c0-.55-.45-1-1-1s-1 .45-1 1v.06c-2.38.29-3.88 1.62-3.88 3.56 0 1.5 1.21 3.01 3.88 3.31v2.98c-1.49-.26-1.88-1.09-2.02-1.75-.12-.54-.65-.89-1.19-.77-.54.12-.88.65-.77 1.19.25 1.15 1.1 3 3.98 3.35V22c0 .55.45 1 1 1s1-.45 1-1v-.06c2.38-.29 3.88-1.62 3.88-3.56 0-1.78-1.53-3.04-3.88-3.32zm-3.88-1.44c0-1.02 1.03-1.39 1.88-1.54v2.83c-1.13-.17-1.88-.66-1.88-1.29zM17 19.91v-2.83c1.13.18 1.88.67 1.88 1.29 0 1.02-1.03 1.4-1.88 1.54z",
  },
}
